import { axios } from 'libs';

const resource = '/processos-arquivos';

export const analisar = analise => {
  return axios.put(`${resource}/analisar`, analise);
};

export const salvarArquivos = (processoId, files) => {
  const promises = files
    .map(file => {
      const formData = new FormData();

      formData.append('files', file);

      if (file.documento) {
        formData.append('documento', file.documento.id);
      }

      return formData;
    })
    .map(data => {
      let url = `${resource}/arquivo`;

      if (data.get('documento')) {
        url = `${url}/documento/${data.get('documento')}`;
      }

      return axios.post(`${url}${processoId}`, data);
    });

  return Promise.all(promises);
};

export const agruparArquivosEmUnicoPdf = (agrupamento, processoId) => {
  return axios.post(`${resource}/agrupar-arquivos${processoId}`, agrupamento);
};

export const salvarArquivoTemplate = (processoId, template) => {
  return axios.post(`${resource}/template${processoId}`, template);
};

export const salvarArquivoPdf = (
  processoId,
  templateHtml,
  fileName = 'modeloDocumentoProcesso'
) => {
  const exporterParam = {
    type: 'PDF',
    fileName
  };

  return axios.post(`${resource}/template-pdf${processoId}`, {
    name: fileName,
    text: templateHtml,
    exporterParam
  });
};

export const alterarOrdemArquivos = (id, newFiles) => {
  return axios.put(`${resource}/alterar-ordem/${id}`, newFiles);
};
